import { useTranslation } from "react-i18next";
import { pick } from "src/utils/localize";
import WhatsappCta from "./whatsapp-cta";

// ЦЕЛЕВАЯ КНОПКА ТУРА ИЛИ УСЛУГИ.
//
// Ведёт в WhatsApp с готовым сообщением — как и все остальные кнопки заявки
// на сайте (см. src/sections/components/whatsapp-cta.jsx). Из админки берётся
// только подпись `ctaLabel` («Оформить визу», «Забронировать место»); пустая —
// показываем общую надпись из переводов.
//
// Прежний переключатель «форма или WhatsApp» (`ctaType`) больше ни на что не
// влияет: канал теперь один для всего сайта. Поле в базе оставлено, чтобы не
// ломать существующие записи.
const SOLID =
  "px-8 bg-kj-gold text-kj-dark hover:bg-kj-gold/90 uppercase tracking-[0.08em] text-sm font-bold rounded-sm";
const OUTLINE =
  "border border-kj-gold text-kj-gold bg-transparent hover:bg-kj-gold hover:text-kj-dark uppercase tracking-[0.08em] text-xs font-bold rounded-sm";

export default function CtaButton({
  item,
  subject,
  details = [],
  fallbackLabel,
  className = "",
  variant = "solid",
  intent = "ask",
  // Какую анкету показать перед WhatsApp. У услуги это настраивается
  // в админке; тур всегда спрашивает имя и количество человек.
  form = "basic",
  // Заготовка: опции, выбранные калькулятором на странице тура.
  presetComment = "",
}) {
  const { t, i18n } = useTranslation();
  const outline = variant === "outline";

  return (
    <WhatsappCta
      subject={subject}
      details={details}
      extra={presetComment}
      intent={intent}
      form={form}
      label={pick(item?.ctaLabel, i18n.language) || fallbackLabel || t("request.trigger")}
      variant={outline ? "outline" : "default"}
      size={outline ? "default" : "lg"}
      withIcon={!outline}
      className={`${outline ? OUTLINE : SOLID} ${className}`}
    />
  );
}
